module.exports = __webpack_public_path__ + "static/media/db.da9f7b8d.svg";